import { makeStyles } from '@material-ui/core';

export const useProgressIndicatorStyles = makeStyles((theme) => ({
  progressItemContainerRoot: {
    width: '120px',
  },
}));
